import { render, staticRenderFns } from "./SuggestedProgram.vue?vue&type=template&id=88032c76&scoped=true&"
import script from "./SuggestedProgram.vue?vue&type=script&lang=ts&"
export * from "./SuggestedProgram.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestedProgram.vue?vue&type=style&index=0&id=88032c76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88032c76",
  null
  
)

export default component.exports